export default "__VITE_ASSET__D74lAs8m__"